"use client";

import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = ({
  phoneNumber = "919996108446",
  message = "Hello! I want to inquire about FWPI.",
}) => {
  return (
    <>
      <style jsx>{`
        .whatsapp-float {
          position: fixed;
          bottom: 20px;
          right: 20px;
          background-color: #25d366;
          color: #fff;
          width: 65px;
          height: 65px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
          z-index: 9999;
          cursor: pointer;
          animation: pulse 2s infinite ease-in-out;
          transition: transform 0.2s ease-in-out;
        }

        .whatsapp-float:hover {
          transform: scale(1.15);
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
          }
        }

        @media (max-width: 600px) {
          .whatsapp-float {
            bottom: 15px;
            right: 15px;
            width: 55px;
            height: 55px;
          }
        }
      `}</style>

      <a
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(
          message
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <FaWhatsapp size={35} />
      </a>
    </>
  );
};

export default WhatsAppButton;
